<div class="nav" #nav (window:resize)="onResize($event)">
  @if(!inputMode()) {
  <div class="actions">
    <span>{{ cursorMode }} mode</span>&nbsp;
    <div style="display: inline-block">&nbsp;</div>
    <!--
      <ng-template [ngIf]="!pause">
        <button class="btn btn-secondary" (click)="getWeatherClick()">
          <span class="mdi mdi-weather-partly-cloudy"></span> Weather
        </button>
      </ng-template>
      -->
    @if(pause()) {
    <button class="btn btn-secondary" [class.has-range]="cursorMode === 'ranged'" (click)="nextPointClick()"><span class="mdi mdi-select"></span> Create range</button>
    <button class="btn btn-secondary" (click)="addPoint()">
      <span class="mdi mdi-plus-circle-outline"></span> Save @if (cursorMode === 'range') {
      <span>point</span>
      } @if(cursorMode === 'ranged') {
      <span>range</span>
      }
    </button>
    @if(canAnnotate()) {
    <button class="btn btn-secondary" (click)="annotatePoint()">
      <span class="mdi mdi-plus-circle-outline"></span> Annotate @if (cursorMode === 'range') {
      <span>point</span>
      } @if(cursorMode === 'ranged') {
      <span>range</span>
      }
    </button>
    }
    <span (click)="pause.set(false); cursorMode = 'free'" class="mdi mdi-window-close"></span>
    }
  </div>
  } @else {
  <div class="input">
    <input autofocus [(ngModel)]="inputText" />
    <button class="btn btn-secondary">
      <span class="mdi mdi-content-save-edit-outline"></span>
      Save
    </button>

    <button class="btn btn-secondary" (click)="inputMode = null">
      <span class="mdi mdi-window-close"></span>
      Cancel
    </button>
  </div>
  }
</div>

<article>
  @if (item()?.telemetry?.d && (!hasToClickToInteract() || (hasToClickToInteract() && hasClicked()))) {
  <section class="info" #info [style.left.px]="mouseX()" [style.top.px]="mouseY()">
    <p>&nbsp; {{ item().telemetry.d | amDateFormat: 'ddd Do MMMM HH:mm' }} &nbsp;</p>
    @if (pause()) {
    <nav>
      @if (canAnnotate()) {
      <i class="mdi mdi-pencil-outline" title="Annotate" tooltipPosition="top" (click)="annotateClick()"></i>
      } @if (canZoom) {
      <i class="mdi mdi-magnify-plus-outline" title="Zoom in here" (click)="zoomIn(item().telemetry.d)" tooltipPosition="top"></i>
      } @if (isAdmin) {
      <i class="mdi mdi-shield-account-outline" title="Admin Info" (click)="clickAdmin()" tooltipPosition="top"></i>
      } @if (history.length && canZoom) {
      <i class="fa fa-fw fa-search-minus" title="Zoom out" (click)="zoomOut()"></i>
      }
      <i class="mdi mdi-close" title="Close" (click)="pause.set(false)" tooltipPosition="right"></i>
    </nav>
    }

    <div class="hover-values">
      <p><span>Value</span> {{ item().telemetry.v }}</p>
      @if (item().telemetry.rag) {
      <p>
        <span>RAG</span>
        <span class="red" [style.opacity]="item().telemetry.rag === 'red' ? 1 : 0.2"><i class="fa fa-fw fa-circle"></i></span>
        <span class="orange" [style.opacity]="item().telemetry.rag === 'amber' ? 1 : 0.2"><i class="fa fa-fw fa-circle"></i></span>
        <span class="green" [style.opacity]="item().telemetry.rag === 'green' ? 1 : 0.2"><i class="fa fa-fw fa-circle"></i></span>
      </p>
      } @if (item().telemetry.w) {
      <p>
        <span>Ambient</span>&nbsp;
        <app-weather-temp [weather]="{ icon: item().telemetry.w.i, temp: item().telemetry.w.t }"></app-weather-temp>
      </p>
      } @if (item().telemetry.annotation) {
      <p class="annotation-text">{{ item().telemetry.annotation.text }}</p>
      } @if (item().pin) {
      <div>
        <div><i class="mdi mdi-pin"></i> {{ item().pin.text }}</div>
        <div class="italic">{{ item().pin.date | amDateFormat: 'ddd Do MMMM HH:mm' }}</div>
      </div>
      } @if (item().annotation) {
      <div>
        <div><i class="mdi mdi-pin"></i> {{ item().annotation.text }}</div>
        <div class="italic">{{ item().annotation.createdAt | amDateFormat: 'ddd Do MMMM HH:mm' }}</div>
      </div>
      } @if (showAdminData) { @if (dateFrom || dateTo) {
      <div>
        <div style="font-size: 10px" title="Overrides telemetry">{{ dateFrom | date: 'dd MMM yy HH:mm' }} - {{ dateTo | date: 'dd MMM yy HH:mm' }}</div>
      </div>
      } @else {
      <div>
        <div style="font-size: 10px" title="telemetry dates">{{ telemetryFrom | date: 'dd MMM yy HH:mm' }} - {{ telemetryTo | date: 'dd MMM yy HH:mm' }}</div>
      </div>
      } }
    </div>
  </section>
  }
</article>

@if (isShowingPanel()) {
<app-dialog header="Annotation" (onClose)="isShowingPanel.set(false)" [dimensions]="{ width: 600, height: 306 }">
  <app-d3-chart-annotate [item]="item()" [asset]="_asset" (onClose)="isShowingPanel.set(false)" />
</app-dialog>
} @if (isShowingAssetDashboard()) {
<div class="fullscreen">
  <app-asset-dashboard [asset]="asset" (onGoBack)="isShowingAssetDashboard.set(false)"></app-asset-dashboard>
</div>
}
<svg></svg>
